// extracted by mini-css-extract-plugin
module.exports = {"emblaButton":"embla-button_emblaButton__LoOnN"};